<template>
	<b-container v-b-modal.interviewPrepModal class="prepareInt-main-container">
		<header id="hideinlaptop" class="mob-back-header">
			<img
				class="mr-3 pointer"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="
					upperText !== 'Prepare for an Interview' ? goBack() : $router.go(-1)
				"
			/>{{ upperText }}
		</header>
		<div class="preint-down-cont">
			<div
				@click="
					$route.query.from === 'home'
						? $router.push({ name: 'Homepage' })
						: $router.push({ name: 'CandidateDashboard' })
				"
				id="hideinmobile"
				class="d-flex align-items-center preint-black-txt"
			>
				<img
					class="mr-2 pointer"
					src="../../assets/blue-bckarrow.svg"
					alt=""
				/>Prepare for an Interview
			</div>
			<div class="preint-flex-cont">
				<section
					:class="clickedSkill && !isLaptop ? 'd-none' : 'preint-left-cont'"
				>
					<main v-if="!showMobileView" class="preint-left-top">
						<span class="preint-black-txt-2">
							Search for additional skills to expand your options
						</span>
						<div class="preint-search position-relative mt-2">
							<b-form-input
								placeholder="Search more skills"
								debounce="500"
								@update="searchSkills"
								clearable
								:disabled="shimmer"
							></b-form-input>
							<img
								class="preint-search-pos"
								src="../../assets/newdesign/jobsearch/blueSearch.svg"
								alt=""
							/>
						</div>
					</main>
					<main
						v-if="
							profileSkills.length < 1 &&
							recommendedSkills.length < 1 &&
							!shimmer
						"
						class="preint-left-bottom"
					>
						<h3 class="preint-black-txt-3 p-3">Search Result</h3>
						<div class="preint-nosearch">
							<img
								src="../../assets/newdesign/myprofile/noSearchResult.svg"
								alt=""
							/>
							<span class="preint-grey-txt mt-3 text-center text-break px-5"
								>No matching results for “{{ noSearchText }}"</span
							>
						</div>
					</main>
					<main v-else-if="!showMobileView" class="preint-left-bottom">
						<section class="preint-skill-search-box">
							<h3 class="preint-black-txt-3">
								Skills from your primary profile
							</h3>

							<div class="preint-search-scroll">
								<div v-if="shimmer">
									<div
										v-for="i in 5"
										:key="i + 'per-skl'"
										class="preint-skill-card"
									>
										<div
											class="mb-0 preint-w-50 text-truncate d-flex pr-2 pl-1 d-flex justify-content-between preint-mt w-100"
										>
											<b-skeleton class="w-25 h-15"></b-skeleton>
											<b-skeleton class="mr-4 w-15 h-15"></b-skeleton>
											<b-skeleton class="mr-4 w-15 h-15"></b-skeleton>
										</div>
									</div>
								</div>

								<div v-else>
									<div
										v-for="(skill, ind) in profileSkills"
										:key="'pSkill' + ind"
										class="mb-2 pointer"
										:class="
											ind == selectedProfileInd
												? 'preint-skill-card-sel'
												: 'preint-skill-card'
										"
										@click.stop="
											ind == selectedProfileInd && isLaptop
												? ''
												: profileSkillSel(skill, ind)
										"
									>
										<div id="hideinmobile" class="preint-blue-left"></div>
										<h3
											class="preint-black-txt-4 mb-0 preint-w-50 text-truncate d-flex pr-2 pl-1"
										>
											<div class="w-100 text-capitalize">{{ skill.name }}</div>
											<img
												id="hideinlaptop"
												src="../../assets/newdesign/myprofile/blueArrow.svg"
												alt=""
											/>
										</h3>
										<div
											class="d-flex justify-content-between preint-w-50 preint-mt"
										>
											<h3 class="preint-grey-txt mb-0">
												{{ skill.expertise_level }}
											</h3>
											<h3 class="preint-grey-txt mb-0 preint-color-blue">
												{{ skill.test_count }} Test
											</h3>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section class="preint-recom-skill">
							<h3 class="preint-black-txt-3">Recommended Skills</h3>
							<div class="preint-recom-skill-scroll">
								<template v-if="shimmer" class="">
									<div
										v-for="i in 4"
										:key="i + 'prep-rec-skl'"
										class="preint-recom-box preint-skill-card"
									>
										<b-skeleton class="w-50 h-15"></b-skeleton>
									</div>
								</template>

								<template v-else>
									<div
										v-for="(skill, ind) in recommendedSkills"
										:key="'rSkill' + ind"
										class="preint-recom-box pointer text-capitalize"
										:class="
											ind == selectedRecommendedInd
												? 'preint-skill-card-sel weight-700 justify-content-between'
												: 'preint-skill-card'
										"
										@click.stop="
											ind == selectedRecommendedInd && isLaptop
												? ''
												: profileSkillSel(skill, ind)
										"
									>
										<div>{{ skill.name }}</div>
										<span
											id="hideinmobile"
											v-if="ind == selectedRecommendedInd"
											class="myp-blue-color white-space-no-wrap"
											>{{ skill.test_count }} Test</span
										>
										<div id="hideinmobile" class="preint-blue-left"></div>
									</div>
								</template>
							</div>
						</section>
					</main>
				</section>
				<section class="preint-right-cont">
					<template v-if="shimmerRight && isLaptop">
						<div class="preint-right-blue-box w-100">
							<b-skeleton class="w-50 h-15"></b-skeleton>
						</div>
						<div class="preint-shimmer-overflow overflow-auto">
							<div v-for="i in 2" class="preint-right-content-box mt-1">
								<div class="preint-black-txt w-20">
									<b-skeleton class="w-25 h-15"></b-skeleton>
								</div>
								<div v-for="i in 3">
									<div
										class="d-flex preint-grey-txt-2 weight-500 preint-content-box"
									>
										<b-skeleton-img
											no-aspect
											height="60px"
											class="mt-2"
										></b-skeleton-img>
									</div>
								</div>
							</div>

							<div
								class="d-flex align-items-center justify-content-between my-2 mt-3"
							>
								<div class="w-75">
									<div class="mb-1">
										<b-skeleton class="w-25 h-15"></b-skeleton>
									</div>
									<div class="mb-0 pr-5">
										<b-skeleton class="w-50 h-15"></b-skeleton>
									</div>
								</div>
							</div>
							<div class="preint-assessment-option-box mt-2">
								<div v-for="i in 3" class="preint-assess-option">
									<b-skeleton class="w-50 h-15"></b-skeleton>
								</div>
							</div>
						</div>
					</template>
					<template v-else-if="isLaptop || showMobileView">
						<div class="preint-right-blue-box">
							<span
								>Suggestions for
								<span class="weight-600 text-capitalize"
									>“{{ selectedCard }}”</span
								></span
							><span class="preint-ai">
								Hire3x
								<img
									class="ml-1"
									src="../../assets/newdesign/myprofile/smallAi.svg"
									alt=""
								/>
							</span>
						</div>
						<main
							class="app-bottom-padding"
							:class="
								testInfo.length >= 1
									? 'preint-right-content-box mt-1'
									: 'preint-right-content-box-no-test mt-1'
							"
							ref="divScroll"
						>
							<template v-if="selectedRecommendedInd == null">
								<div class="preint-black-txt">Revision</div>
								<div class="preint-grey-txt-2 mt-2 mb-2 text-capitalize">
									{{ selectedCard }}
								</div>
								<div
									v-for="(rSkill, ind) in revisionList"
									:key="'rSkill' + ind"
								>
									<div
										class="d-flex preint-grey-txt-2 weight-500 preint-content-box"
									>
										<span>{{ ind + 1 }}.&nbsp;</span>
										<div>
											<!-- Oracle Java Tutorials**: Start with the official tutorials
									provided by Oracle. They cover everything from basic syntax to
									more advanced topics.<br />&nbsp;&nbsp;[Oracle Java
									Tutorials](<span class="preint-color-blue"
										>https://docs.oracle.com/javase/tutorial/</span
									>) -->
											{{ rSkill }}
										</div>
									</div>
									<hr v-if="ind + 1 !== revisionList.length" class="hr-back" />
								</div>
								<hr class="white-hr" />
							</template>
							<div class="preint-black-txt">Preparation</div>
							<div class="preint-grey-txt-2 mt-2 mb-2">{{ selectedCard }}</div>
							<!-- <div class="preint-grey-txt-2 mt-2 mb-2 text-capitalize">
								{{ selectedCard }}
							</div> -->
							<div
								v-for="(prepSkill, ind) in preparationList"
								:key="'prepSkill' + ind"
							>
								<div
									class="d-flex preint-grey-txt-2 weight-500 preint-content-box"
								>
									<span>{{ ind + 1 }}.&nbsp;</span>
									<div>
										{{ prepSkill }}
									</div>
								</div>
								<hr v-if="ind + 1 !== preparationList.length" class="hr-back" />
							</div>
						</main>
						<template v-if="testInfo.length > 0">
							<hr class="hr-back my-2" />
							<div class="d-flex align-items-center justify-content-between">
								<div class="w-75">
									<h3 class="preint-black-txt-3 mb-1">Take Assessment</h3>
									<h3 class="preint-grey-txt mb-0 pr-5">
										Choose your level, click, and conquer the challenge ahead.
									</h3>
								</div>
								<div
									class="preint-black-txt-4 weight-600 preint-color-blue d-flex pointer"
									@click="viewMoreAssessment"
								>
									View All <span id="hideinmobile">&nbsp;Assessments</span
									><img
										class="ml-2"
										src="../../assets/newdesign/myprofile/blueRightArrow.svg"
										alt=""
									/>
								</div>
							</div>
							<main class="preint-assessment-option-box mt-2">
								<div
									v-for="(test, ind) in testInfo"
									:key="'test' + ind"
									class="preint-assess-option"
								>
									<span
										class="preint-black-txt-4 text-truncate w65 text-capitalize"
									>
										{{ test.name }}
									</span>
									<span
										@click="getPublicAssessments(test.testID)"
										class="preint-blue-txt pointer"
										><span id="hideinmobile">Take Test</span>
										<img
											class="ml-1"
											src="../../assets/newdesign/myprofile/blueArrow.svg"
											alt=""
									/></span>
								</div>
							</main>
						</template>
					</template>
				</section>
			</div>
		</div>
		<TestDetails
			ref="testDetails"
			v-if="showTestDetails == true && isLaptop"
			:public="true"
			:selectedAssessment="selectedAssessment"
			:showTestDetails="showTestDetails"
			@closeTestModal="closeTestModal"
			@purchase-success="handlePurchaseSuccess"
		/>
		<div style="display: none" ref="responseContainer"></div>
	</b-container>
</template>

<script>
import mobileHeader from "@/components/fixedcomponents/mobileHeader.vue";
import TestDetails from "../AssessmentProgress/TestDetailsAP.vue";
import {
	postCandInterDetails,
	getPublicAssessments,
	postPrepAndRevision,
} from "../../utils/apiFunctions";
import commonFunc from "@/components/mixin/commonFunction.js";
import { Capacitor } from "@capacitor/core";

import payment from "@/components/mixin/payment";
import { mapGetters } from "vuex";
export default {
	name: "PrepareInterview",
	data() {
		return {
			loopvar: 7,
			loopvar2: 4,
			profileSkills: [],
			fixedProfileSkills: [],
			recommendedSkills: [],
			fixedRecommendedSkills: [],
			preparationList: [],
			revisionList: [],
			testInfo: [],
			savedTempData: [],
			shimmer: true,
			shimmerRight: true,
			showMobileView: false,
			clickedSkill: false,
			selectedCard: "",
			noSearchText: "",

			selectedRecommendedInd: null,
			selectedProfileInd: null,
			upperText: "Prepare for an Interview",
			showTestDetails: false,
			selectedAssessment: {},
		};
	},
	mixins: [commonFunc, payment],
	components: {
		mobileHeader,
		TestDetails,
	},
	created() {
		this.getPrimaryProfileInfo();
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		handlePurchaseSuccess() {
			this.assessment.purchased = true;
		},
		profileSkillSel(skill, ind) {
			this.clickedSkill = true;
			this.assignToSideList(skill, ind);
		},
		viewMoreAssessment() {
			this.$router.push({
				name: "AssessmentMarketplace",
			});
		},
		async getPrimaryProfileInfo() {
			try {
				await this.getCandidatePrimaryProfile();
				let payload = {};
				payload.skills = this.candidateData.skills
					.filter((link) => link.parser != true)
					.reduce((acc, skill) => {
						acc[skill.skillName] = skill.expertiseLevel;
						return acc;
					}, {});

				const resp = await postCandInterDetails(payload);
				if (resp.status === 200) {
					const allResp = resp.data.data.data;

					this.fixedProfileSkills = allResp.profile_skills;
					this.fixedRecommendedSkills = allResp.suggested_skills;
					// this.fixedProfileSkills = resp.data.data.data
					// 	.filter((skill) => skill.suggested === false)
					// 	.map((skill) => {
					// 		const { ...newSkill } = skill;
					// 		return newSkill;
					// 	});

					// this.fixedRecommendedSkills = resp.data.data
					// 	.filter((skill) => skill.suggested === true)
					// 	.map((skill) => {
					// 		const { ...newSkill } = skill;
					// 		return newSkill;
					// 	});
					this.profileSkills = this.fixedProfileSkills;
					this.recommendedSkills = this.fixedRecommendedSkills;
					this.assignToSideList(this.profileSkills[0], 0);
				} else {
					console.log("Inter Api Error");
				}
			} catch (error) {
				console.error(error);
			}
			this.shimmer = false;
		},

		async assignToSideList(data, ind = null) {
			this.shimmerRight = true;
			if (data.suggested) {
				this.selectedRecommendedInd = ind;
				this.selectedProfileInd = null;
			} else {
				this.selectedRecommendedInd = null;
				this.selectedProfileInd = ind;
			}
			if (data) {
				const skillNames = data.name;
				let payload = {
					skills: {
						[skillNames]: data.expertise_level,
					},
				};
				const resp = await postPrepAndRevision(payload);
				let prepDataResp = {};
				if (resp.status == 200) {
					prepDataResp = resp.data.data.data;
				}

				this.savedTempData = data;
				this.selectedCard = prepDataResp.name;
				this.preparationList = prepDataResp.preparation;
				this.revisionList = prepDataResp.suggestion;
				this.testInfo = data.test_info;
				this.testInfo =
					this.testInfo.length > 4 ? this.testInfo.slice(0, 4) : this.testInfo;
				if (!this.isLaptop && this.clickedSkill) {
					this.showMobileView = true;
					this.upperText = this.selectedCard;
				} else if (this.$refs.divScroll) {
					this.$refs.divScroll.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				}
			}
			this.shimmerRight = false;
		},

		searchSkills(searchTerm) {
			const lowercasedTerm = searchTerm ? searchTerm.toLowerCase() : "";

			// Update profileSkills and recommendedSkills based on search term
			this.profileSkills = lowercasedTerm
				? this.fixedProfileSkills.filter((skill) =>
						skill.name.toLowerCase().includes(lowercasedTerm)
				  )
				: this.fixedProfileSkills;

			this.recommendedSkills = lowercasedTerm
				? this.fixedRecommendedSkills.filter((skill) =>
						skill.name.toLowerCase().includes(lowercasedTerm)
				  )
				: this.fixedRecommendedSkills;
			if (this.profileSkills.length > 0) {
				this.assignToSideList(this.profileSkills[0], 0);
			} else if (this.recommendedSkills.length > 0) {
				this.assignToSideList(this.recommendedSkills[0], 0);
			} else {
				// Reset selected skills and lists if no matches
				this.noSearchText = searchTerm;
				this.selectedRecommendedInd = null;
				this.selectedProfileInd = null;
				this.selectedCard = "";
				this.preparationList = [];
				this.revisionList = [];
				this.assignToSideList(this.savedTempData);
			}
		},
		goBack() {
			this.clickedSkill = false;
			this.showMobileView = false;
			this.upperText = "Prepare for an Interview";
		},

		async routeToTakeTest(data) {
			this.showTestDetails = true;
			this.selectedAssessment = JSON.parse(JSON.stringify(data));
			this.selectedAssessment.proctoringType = this.getProctoringType(
				this.selectedAssessment
			);
			if (this.selectedAssessment.shareLink) {
				if(!Capacitor.isNativePlatform()){
				this.selectedAssessment.shareLinkWithQuery = this.appendQuery(
					this.selectedAssessment.shareLink,
					{
						key: "from",
						value: "candidate",
					}
				);
				}else{
					this.selectedAssessment.shareLinkWithQuery = this.selectedAssessment.shareLink;
				}
			}
			if (!this.isLaptop) {
				this.$store.commit(
					"candidateVUEX/addSelectAssess",
					this.selectedAssessment
				);
				this.$router.push({
					name: "mobAssessment",
					query: {
						public: true,
						from: "home",
					},
				});
			}
		},
		 appendQuery(link, query) {
			// let url = new URL(link);
			// url.searchParams.append(query.key, query.value);
			// return url.href;
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append(query.key, query.value);

				return `${baseUrl}#${path}?${params.toString()}`;
			} else {
				const url = new URL(link);
				url.searchParams.append(query.key, query.value);

				return url.href;
			}
		},
		closeTestModal(val) {
			this.showTestDetails = val;
			this.selectedAssessment = {};
		},
		getProctoringType(assessment) {
			let proctoringTypes = [];
			if (assessment.config.allowAgent) proctoringTypes.push("agent");
			if (assessment.config.allowExtension) proctoringTypes.push("extension");
			if (assessment.config.enableProctoring) proctoringTypes.push("video");
			return proctoringTypes.join("-");
		},
		async getPublicAssessments(testId) {
			const res = await getPublicAssessments({
				email: this.candidateData.email,
				searchQuery: "",
				testID: testId,
			});
			if (res.status == 200) {
				const assessmentDetails = res.data.data.data;
				this.routeToTakeTest(assessmentDetails[0]);
			}
		},
	},
};
</script>

<style>
.prepareInt-main-container {
	max-width: 100%;
	background-color: var(--bg-lightblueback);
	height: calc(100vh - 60px);
	top: 60px;
	position: relative;
	padding: 15px 15px 15px 75px;
	display: flex;
	justify-content: center;
}

.preint-down-cont {
	height: 100%;
	width: 100%;
	background-color: var(--bg-white);
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	border-radius: 8px;
	padding: 12px 15px;
	max-width: 1750px;
}

.preint-black-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-20);
	font-weight: var(--weight-LM);
	color: var(--cv-black);
}

.preint-black-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--cv-lightGray);
}
.preint-black-txt-3 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: var(--cv-black);
}

.preint-black-txt-4 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: #3e323e;
}
.preint-grey-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	color: var(--cv-gray);
}
.preint-grey-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: #333333;
}
.preint-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--bg-proTheme);
}
.weight-700 {
	font-weight: var(--weight-B);
}
.weight-600 {
	font-weight: var(--weight-M);
}
.weight-500 {
	font-weight: var(--weight-LM);
}
.preint-color-blue {
	color: var(--bg-proTheme);
}
.preint-flex-cont {
	display: flex;
	width: 100%;
	margin-top: 12px;
	gap: 12px;
}

.preint-left-cont {
	width: 45%;
	box-shadow: 0px 0px 10px 0px #c4c4c480;
	height: 100%;
	border-radius: 8px;
}

.preint-right-cont {
	width: 55%;
}

.preint-search .form-control {
	background-color: #72738e14;
	border-radius: 8px;
	height: 32px;
	padding: 3px 8px 6px 29px;
	border: none;
}

.preint-left-top {
	padding: 10px 15px 15px 15px;
	border-bottom: 1px solid #d9d9d9;
}

.preint-search .form-control:focus {
	background-color: #72738e14;
	border-radius: 8px;
	height: 32px;
	padding: 3px 8px 6px 29px;
	box-shadow: none;
	border: none;
	width: 100%;
}

.preint-search-pos {
	position: absolute;
	top: 8px;
	left: 7px;
}

.preint-left-bottom {
	height: calc(100vh - 248px);
	overflow: auto;
}

.preint-skill-search-box {
	padding-block: 10px;
	border-bottom: 1px solid #dddddd;
	margin-inline: 15px;
}

.preint-skill-card {
	border: 1px solid #20639b1f;
	border-radius: 5px;
	position: relative;
	padding: 8px;
	display: flex;
	align-items: center;
}

.preint-skill-card-sel {
	border: 1px solid #20639b1f;
	border-radius: 5px;
	position: relative;
	padding: 8px;
	display: flex;
	align-items: center;
	background-color: #e2ebf2;
	border: 1px solid #20639b1f;
}

.preint-skill-card .preint-blue-left {
	position: absolute;
	height: 83%;
	width: 3px;
	border-radius: 4px;
	background-color: var(--bg-white);
	left: 3px;
}

.preint-skill-card-sel .preint-blue-left {
	position: absolute;
	height: 83%;
	width: 3px;
	border-radius: 4px;
	background-color: var(--bg-proTheme);
	left: 3px;
}
.preint-w-50 {
	width: 50%;
}

.preint-search-scroll {
	min-height: auto;
	max-height: calc(100vh - 430px);
	overflow: auto;
	padding-right: 3px;
}

.preint-recom-skill {
	padding: 10px 15px;
}

.preint-recom-skill-scroll {
	min-height: auto;
	max-height: 200px;
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.preint-recom-box {
	padding: 5px 10px;
	width: calc((100% - 10px) / 2);
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: #3e323e;
}

.preint-nosearch {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: calc(100vh - 350px);
}

.preint-right-blue-box {
	background-color: var(--bg-proTheme);
	border-radius: 10px 10px 0px 0px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: var(--bg-white);
	padding: 8px 14px;
}

.preint-ai {
	display: flex;
	align-items: center;
	font-family: "Lato", sans-serif;
	font-size: var(--size-12);
	font-style: italic;
	font-weight: var(--weight-LM);
	color: #595959;
	border-radius: 12px;
	background-color: #f6f9fb;
	padding: 2px 12px;
}

.preint-right-content-box {
	background: #e2ebf294;
	border-radius: 5px;
	padding: 12px 15px;
	min-height: auto;
	max-height: calc(100vh - 355px);
	overflow: auto;
}
.preint-right-content-box-no-test {
	background: #e2ebf294;
	border-radius: 5px;
	padding: 12px 15px;
	height: calc(100dvh - 200px);
	overflow: auto;
}

.preint-content-box {
	color: var(--cv-black);
}

.white-hr {
	border-top: 2px solid var(--bg-white);
	opacity: 1;
}

.hr-back {
	opacity: 0.6;
}

.preint-assessment-option-box {
	background-color: var(--bg-white);
	border: 1px solid #20639b40;
	padding: 10px;
	display: flex;
	flex-wrap: wrap;
	border-radius: 5px;
	gap: 10px;
}

.preint-assess-option {
	width: calc((100% - 10px) / 2);
	background-color: #f7f9fb;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 5px 10px;
	flex-shrink: 0;
}

.preint-shimmer-overflow {
	height: calc(100vh - 200px);
}

@media (max-width: 1028px) {
	.prepareInt-main-container {
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		top: unset;
		padding: unset;
		display: block;
	}
	.preint-down-cont {
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		max-width: unset;
		background-color: var(--bg-lightblueback);
		border: 1px solid #8c8c8c54;
		box-shadow: 0px 4px 8px 0px #0000002b;
		border-radius: 0px;
		padding: 15px;
		position: fixed;
		top: unset;
		width: 100%;
	}
	.preint-flex-cont {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		margin-top: unset;
		gap: 12px;
	}
	.preint-left-cont {
		width: 100%;
		box-shadow: none;
		height: 100%;
		border-radius: 8px;
	}
	.preint-left-top {
		padding: 0;
		border-bottom: none;
	}
	.preint-left-bottom {
		height: calc(100% - 70px);
		background-color: var(--bg-white);
		border-radius: 4px;
		margin-top: 10px;
	}
	.preint-search-scroll {
		min-height: auto;
		max-height: calc(100vh - 352px);
		overflow: auto;
		padding-right: 3px;
	}
	.preint-skill-card-sel,
	.preint-skill-card {
		border: 1px solid #20639b1f;
		border-radius: 5px;
		position: relative;
		padding: 8px;
		display: flex;
		flex-direction: column;
		align-items: unset;
	}
	.preint-skill-card-sel {
		align-items: unset;
		background-color: unset;
	}
	.preint-w-50 {
		width: 100%;
		padding: 0px !important;
	}

	.preint-mt {
		margin-top: 5px;
	}
	.preint-right-cont {
		width: 100%;
		height: 100%;
		overflow: auto;
	}
	.preint-right-content-box {
		background: var(--bg-white);
		border-radius: 5px;
		padding: 12px 15px;
		min-height: auto;
		max-height: 65%;
		overflow: auto;
	}
	.preint-skill-search-box {
		padding-block: 10px;
		padding-inline: 15px;
		border-bottom: 1px solid #dddddd;
		margin-inline: unset;
	}
	#hideinmobile {
		display: none !important;
	}
}
@media (min-width: 1029px) {
	#hideinlaptop {
		display: none !important;
	}
}
</style>
